/**
 * Shared unit label formatter.
 * Prefers the unit's human-facing name (name / label / household_name) and
 * falls back to the raw unit number. Use this everywhere a unit is rendered
 * so labels are consistent ("TH1", "Allegra 601") instead of bare numbers ("001").
 */
export function formatUnitLabel(unit: any, fallback = 'Sin unidad'): string {
  if (!unit || typeof unit !== 'object') return fallback;
  const candidates = [
    unit.name,
    unit.label,
    unit.household_name,
    unit.householdName,
  ];
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
  }
  const numberCandidates = [unit.unit_number, unit.unitNumber, unit.number];
  for (const candidate of numberCandidates) {
    if (typeof candidate === 'string' && candidate.trim()) return candidate.trim();
    if (typeof candidate === 'number') return String(candidate);
  }
  return fallback;
}
